/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { InputField, DropdownSelectField } from '@jutro/legacy/components';
import { Icon } from '@jutro/components';
import { Link } from '@jutro/router';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import styles from './SubContractorsComponent.module.scss';
import metadata from './SubContractorsComponent.metadata.json5';

function SubContractorsComponent(props) {

    const {
        data: SubcontractorsVM,
        updateWizardData,
        submissionVM,
        SubcontractorsPath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);


    const addSubcontractors = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            SubcontractorsVM.value = SubcontractorsVM.value || []

            const { _xCenter, _dtoName } = SubcontractorsVM;

            const SubcontractorsObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            SubcontractorsVM.pushElement(
                SubcontractorsObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, SubcontractorsVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            SubcontractorsVM.value.splice(index, 1);
            _.set(submissionVM.value, SubcontractorsPath, SubcontractorsVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, SubcontractorsPath, SubcontractorsVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;


            if (path === 'feeSub2') {
                const value = item.feeSub2 ? item.feeSub2 : '';

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            item.feeSub2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (!_.isUndefined(item) && item.subSer1 === 'Oth' && path === 'ifOthExp3') {
                const value = item.ifOthExp3 ? item.ifOthExp3 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.ifOthExp3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'subSer1') {
                const value = (item && item.subSer1) ? item.subSer1 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = SubcontractorsVM.length > 0 && SubcontractorsVM.children[index].subSer1
                    // eslint-disable-next-line security/detect-object-injection
                    ? SubcontractorsVM.children[index].subSer1.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.subSer1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                )
            }


        }, [SubcontractorsVM, handleValueChange, translator])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`SubcontractorsTable`]: {
            data: SubcontractorsVM.value,
        }

    }), [SubcontractorsVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addSubcontractors,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            SubcontractorsVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [SubcontractorsVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={SubcontractorsVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

SubContractorsComponent.propTypes = wizardProps;
export default withRouter(SubContractorsComponent);
